var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommandsLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 438,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 741,
    y: 141,
    width: 438,
    height: 438
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-741 -141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M854.606 427.981 841.831 415.206 881.069 375.969 841.831 336.731 854.606 323.956 906.619 375.969Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.5 218.562 777.5 501.438 1142.5 501.438 1142.5 218.562 777.5 218.562ZM1092.31 245.938C1097.33 245.938 1101.44 250.044 1101.44 255.062 1101.44 260.081 1097.33 264.188 1092.31 264.188 1087.29 264.188 1083.19 260.081 1083.19 255.062 1083.19 250.044 1087.29 245.938 1092.31 245.938ZM1060.38 245.938C1065.39 245.938 1069.5 250.044 1069.5 255.062 1069.5 260.081 1065.39 264.188 1060.38 264.188 1055.36 264.188 1051.25 260.081 1051.25 255.062 1051.25 250.044 1055.36 245.938 1060.38 245.938ZM1028.44 245.938C1033.46 245.938 1037.56 250.044 1037.56 255.062 1037.56 260.081 1033.46 264.188 1028.44 264.188 1023.42 264.188 1019.31 260.081 1019.31 255.062 1019.31 250.044 1023.42 245.938 1028.44 245.938ZM1115.12 474.062 804.875 474.062 804.875 291.562 1115.12 291.562 1115.12 474.062Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.375 410.188 987.375 410.188 987.375 428.438 914.375 428.438Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandsLight);
export default __webpack_public_path__ + "static/media/commands_light.e563d5c952ae7047b05af8047efc3cbf.svg";
export { ForwardRef as ReactComponent };